import { Paths } from '../interfaces/AuthInterface';
import { User } from 'oidc-client';

const relative_post_logout_redirect_uri: string = '/logout/callback';
const relative_redirect_uri: string = '/signin/callback';
const relative_silent_redirect_uri: string = '/silent/callback';

export type TAuthSettings = {
  authorization: string;
  authority: string;
  change_password_uri: string;
  client_id: string;
  post_logout_redirect_uri: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  silent_redirect_uri: string;
};

export type TAppSettings = {
  landing_uri: string;
  login_uri: string;
  logout_uri: string;
  post_logout_redirect_uri: string;
  redirect_uri: string;
  signin_uri: string;
  silent_redirect_uri: string;
};

export const APP_SETTINGS: TAppSettings = {
  landing_uri: '/view/dashboard',
  login_uri: '/login',
  logout_uri: '/logout',
  post_logout_redirect_uri: relative_post_logout_redirect_uri,
  redirect_uri: relative_redirect_uri,
  signin_uri: '/signin',
  silent_redirect_uri: relative_silent_redirect_uri
};

export const AuthRoutesConfig: Paths[] = [{
  routeKey: 'post_logout_redirect_uri',
  exact: true,
  path: APP_SETTINGS.post_logout_redirect_uri
}, {
  routeKey: 'silent_redirect_uri',
  exact: true,
  path: APP_SETTINGS.silent_redirect_uri
}, {
  routeKey: 'redirect_uri',
  exact: true,
  path: APP_SETTINGS.redirect_uri
}, {
  routeKey: 'login_uri',
  exact: true,
  path: APP_SETTINGS.login_uri
}, {
  routeKey: 'signin_uri',
  exact: true,
  path: APP_SETTINGS.signin_uri
}, {
  routeKey: 'logout_uri',
  exact: true,
  path: APP_SETTINGS.logout_uri
}];
